<template>
  <div style="position: relative; background: var(--ks-background-color-light);" :class="{'small-mode': !large_mode, 'large-mode': large_mode, 'todo-event': is_todo_list}" class="event-grid-container elevation pl-1 pr-1 pt-1 pb-0">

    <div v-if="!is_past" class="event-progress-track mt-0 ml-1 mr-1 mb-1">
      <div class="event-progress-fill" :style="{'width': progress_percent + '%'}"></div>
    </div>
    <div class="event-grid" :class="{'past-event': dim_past, 'past-linked-event': dim_past && linked, 'event-grid-linked': linked || source}">


      <!-- NORMAL -->
      <div style="grid-area: arrow; align-content: center; cursor: pointer; user-select: none;" v-if="!linked" @click.stop="large_mode = !large_mode" class="event-grid-arrow">
          <i class="material-icons" v-if="!large_mode">keyboard_arrow_right</i>
          <i class="material-icons" v-if="large_mode">keyboard_arrow_down</i>
      </div>
      <template v-if="!linked && !source">
        <div style="grid-area: time; text-align: left; cursor: pointer;" class="mt-2" @click.stop="open"> 
          <div style="">{{start_time | format_time}}</div>
          <div style="color: var(--ks-font-color-secondary);" class="ks-font-size-s">{{end_time | format_time}}</div>
        </div>

        <div style="grid-area: title; cursor: pointer;" class="pl-1 mt-2" @click.stop="open">
          <div style="">{{title}}</div>
          <div style="color: var(--ks-font-color-secondary);" class="ks-font-size-s">{{subtitle}}</div>
        </div>
      </template>


      <!--- LINKED -->
      <div style="grid-area: arrow; align-content: center; user-select: none;" v-if="linked" class="event-grid-arrow">
        <k-icon small>link</k-icon>
      </div>
 
      <div style="grid-area: title; overflow: hidden; cursor: pointer;" v-if="linked || source">
        <div style="display: grid; grid-template-columns: 40px 1fr; height: 2.4em;">
          <div @click.stop="open_event(event)">
            <div style="">{{start_time | format_time}}</div>
            <div style="color: var(--ks-font-color-secondary);" class="ks-font-size-s">{{event.cached_end_time | format_time}}</div>
          </div>
          <div @click.stop="open_event(event)" class="pl-1">
            <div>{{title}}</div>
            <div style="color: var(--ks-font-color-secondary);" class="ks-font-size-s">{{subtitle}}&nbsp;</div>
          </div>
        </div>
        <tile-event-channel :uuid="event.uuid" type="source"></tile-event-channel>
      </div>


      <!-- Destination -->
      <div style="grid-area: destination;" :class="{'event-grid-destination-linked': linked || source}">
        <div style="display: grid; grid-template-columns: 55px 1fr;" class="event-grid-destination">
          <div class="event-grid-stats">
            <connection-stats :channel="event_group_channel_id" :destchannel="event_channel_id" :event="event"></connection-stats>
          </div>
          <div v-if="event_channel_id">
            <channel :channel="event_channel_id" :event="event" type="destination" @changed="$emit('changed')"></channel>
          </div>
        </div>
      </div>

      <div style="grid-area: actions; text-align: right; display: grid; grid-template-columns: 30px 30px; grid-template-rows: 1fr 1fr;" :class="{'event-grid-buttons-linked': linked || source}" class="mt-1">
        <div>
          <todo-button :uuid="event.uuid" v-if="$is_admin()">
            <template v-slot:off>
              <k-btn size="xs" no-margin icon icon-name="beenhere"></k-btn>
            </template>
            <template v-slot:on>
              <k-btn size="xs" no-margin icon icon-name="beenhere" color="success"></k-btn>
            </template>
          </todo-button>
        </div>
        <div>
        <stop-button :uuid="event.uuid" v-if="is_current">
            <k-btn size="s" no-margin icon icon-name="stop" color="danger"></k-btn>
        </stop-button>
        </div>
        <div>
          <k-btn size="s" no-margin icon icon-name="movie_edit" @click.stop="open_cloudrec(event)"></k-btn>
        </div>
        <div>
          <k-btn v-if="$is_admin()" size="s" no-margin icon icon-name="view_module" :color="is_multiview ? 'success' : 'white'"  @click.stop="add_to_multiview(event)"></k-btn>
        </div>
      </div>
    </div>

    <div v-if="large_mode" class="event-grid event-grid-previews">

      <div style="grid-area: title; display: grid; grid-template-columns: 1fr 1fr 1fr; grid-gap: 5px;" class="pt-1 mb-1">
        <div>
          <monitor-video :closable="false" hide-footer :urls="[{'title':'preview','url': source_url}]">
            <template v-slot:title>Source</template>
          </monitor-video>
        </div>
        <div>
          <monitor-video :closable="false" hide-footer :urls="[{'title':'preview','url': preview_url}]">
            <template v-slot:title>Preview</template>
          </monitor-video>
        </div>
        <div>
          <monitor-video :closable="false" hide-footer :urls="[{'title':'preview','url': live_url}]">
            <template v-slot:title>Live</template>
          </monitor-video>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import datelib from '@/lib/date.js';
import Channel from './Channel'
import ConnectionStats from './ConnectionStats'
import MonitorVideo from '@/components/MonitorVideo'

import EventModel from '@/models/event.js'
import ChannelModel from '@/models/channel.js';
import InstanceModel from '@/models/instance.js';

import StopButton from '../StopEvent'
import TodoButton from '../TodoEvent'
import TileEventChannel from './TileEventChannel'


export default {
	props: {
    "event": Object,
    "linked": {
      type: Boolean,
      default: false
    },
    "source": {
      type: Boolean,
      default: false
    },
    "group-events": {
      type: Array,
      default: () => []
    }
  },
  components: {
    Channel,
    ConnectionStats,
    StopButton,
    TodoButton,
    MonitorVideo,
    TileEventChannel
  },
  filters: {
    ...datelib
  },
	data () {
		return {
			timestamp: undefined,
			updater: undefined,
			large_mode: false,
			is_past: false,
      dim_past: false,
      is_future: false,
      is_current: false,
      is_todo_list: false,
      title: "",
      subtitle: "",
      start_time: undefined,
      end_time: undefined,
      progress_percent: 0,
      event_group_channel_id: undefined,
      event_channel_id: undefined,
      route_channels: [],
      show_linked_events: true,
      live_url: "",
      source_url: "",
      preview_url: "",
      is_multiview: false
		}
	},
  computed: {
    instances() {
      return this.$store.state.instances;
    }
  },
  methods: {
    get_title(event) {
      return EventModel.title(event);
    },
    get_subtitle(event) {
      return EventModel.subtitle(event);
    },
    route_alternative(route_channel) {
      return _.get(this.event, ["system_meta", "route_alternative", route_channel]);
    },

    is_past_event(event) {
      return EventModel.is_past(event, this.timestamp);
    },
    get_state(data, type) {
      var i = data.instance;
      if (typeof(i) != "undefined") {
        var s = i[type];  
        if (typeof(s) != "undefined") {
          return s;
        }
      }
      return;
    },
    get_source_state(data) {
      return this.get_state(data, "source");
    },
    event_group_monitor() {
      var eg = this.event.event_group;
      var alternative = _.get(eg, "system_meta.alternative", "");
      var channel = ChannelModel.channel_by_id(eg.channel_id);
      if (typeof(channel) != "undefined") {
        var id = channel.uuid;
        var data = ChannelModel.status(channel, alternative);
        if (typeof(data) != "undefined") {
          var headend = this.instances[data.headend_instance];
          var state = (this.get_source_state(data)||{}).state;
          return {key: id, state: state, channel: channel, alternative: alternative, url: InstanceModel.headend_preview_url(headend, id, alternative)};
        }
      }
      return {};
    },

    timestamp_update() {
      var self = this;
      this.is_current = EventModel.is_current(this.event, this.timestamp);
      this.is_past = EventModel.is_past(this.event, this.timestamp);
      this.is_future = EventModel.is_future(this.event, this.timestamp);
      this.dim_past = this.is_past && this.groupEvents.some((e) => e.uuid != this.event.uuid && !EventModel.is_past(e, this.timestamp));
      this.is_todo_list = this.get_is_todo_list();
      this.title = EventModel.title(this.event);
      this.subtitle = EventModel.subtitle(this.event);
      this.start_time = this.event.cached_start_time;
      this.end_time = this.event.cached_end_time;
      this.preview_url = EventModel.preview_url(this.event);
      this.live_url = EventModel.live_url(this.event);
      this.source_url = this.event_group_monitor().url;
      this.progress_percent = EventModel.progress_percent(this.event, this.timestamp);
      this.is_multiview = EventModel.is_multiview(this.event);


//      this.route_channels = _.get(this.event, ["system_meta","route_channel"], {});

      this.event_group_channel_id = this.event.event_group.channel_id;
      this.event_channel_id = this.event.channel_id;
    },
    get_progress_percent(event) {
      return EventModel.progress_percent(event, this.timestamp);
    },
    get_is_todo_list () {
      return EventModel.is_todo_list(this.event, this.$store.state.account);
    },
    get_todo_list_status () {
      return EventModel.todo_list_status(this.event, this.$store.state.account);
    },
    open () {
      this.open_event(this.event);
    },
    open_event (event) {
      this.$router.push("/dashboard/event/"+event.uuid+"?tab=schedule&event=" + event.uuid);
    },
    open_cloudrec (event) {
      const route = this.$router.resolve("/cloudrec/event/"+event.uuid);
      window.open(route.href, "_blank");
    },
    add_to_multiview (event) {
      this.is_multiview = EventModel.toggle_multiview(event);
    }
  },
	mounted () {
		var self = this;
		this.timestamp = self.$store.state.timestamp;
		this.timestamp_update();

		this.updater = setInterval(function() {
			self.timestamp = self.$store.state.timestamp;
			self.timestamp_update();
		},1000);
	},
  beforeDestroy() {
    if (typeof(this.updater) != "undefined") {
      clearInterval(this.updater);
    }
  },


}
</script>
<style scoped>
.cut-text { 
    display: inline-block;
    max-width: 98%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
}
.event-progress-track {
  width: 99%;
  height: 5px;
  border-radius: 6px;
  background-color: var(--ks-background-color);
  overflow: hidden;
}

.event-progress-fill {
  height: 100%;
  border-radius: 7px;
  background-color: var(--ks-col-info-dark);
}

.todo-event::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  border-radius: 6px 0 0 6px;
  background-color: var(--ks-col-accent);
}

.past-event {
  opacity: 0.3;
}

.past-linked-event {
  opacity: 0.3;
}

</style>
<style>
.event-grid {
  width: 100%; 
  display: grid; 
  grid-template-columns: 30px 40px 1fr 1.2fr 60px;
  grid-template-areas: "arrow time title destination actions";
  overflow: hidden; 
  font-size: var(--ks-font-size);
  padding-left: var(--ks-padding-1);
  line-height: 16px;
}

.event-grid-linked {
  grid-template-areas: "arrow title title destination actions";
/*  background: var(--ks-background-color-dark);*/
  padding-top: var(--ks-padding-1);
}

.event-grid-previews {
 grid-template-areas: "arrow title title title title";
}
.event-grid-destination-linked {
  margin-top: 2.4em;
}
.event-grid-buttons-linked {
  margin-top: 2.4em !important;
}


.event-grid-container {
  container-type: inline-size;
  container-name: event-grid;
  background: var(--ks-background-color-light);
  padding-bottom: var(--ks-padding-1) !important;
}

@container event-grid (max-width: 600px) {
  .event-grid {
    grid-template-columns: 40px 1fr;
    grid-template-areas: "time title" 
                          "destination destination"
                          ". actions";
  }
  .event-grid .event-grid-arrow {
    display: none;
  }
  .event-grid .event-grid-stats {
    display: none;
  }
  .event-grid-subevent {
    grid-template-columns: 40px 1fr;
    grid-template-areas: "title title" 
                          "destination destination"
                          ". actions";
  }
  .event-grid .event-grid-destination {
    width: 100%;
    grid-template-columns: 1fr !important;
  }
}



.small-mode {
  height: auto; /*80px;*/
}
.large-mode {
  height: auto;
}

</style>